// extracted by mini-css-extract-plugin
export default {"triggerElement":"customizedDropdownMenuTriggerElement_triggerElement__AY1NP"};